import { app } from "@/main";

export default function errorHandler(error) {
  const status = error.response?.status;

  if (status === 401) {
    location.pathname = "/login?ref=expired";
  } else {
    const id = `error-toast-${Date.now()}`;
    let message =
      error?.response?.data?.errors?.[0]?.message ||
      error?.response?.data?.error ||
      "There was a problem processing your request. Please try again or contact support.";
    let title = "Error";

    // Check if app and app.$bvToast are available before calling toast
    if (app && app.$bvToast) {
      app.$bvToast.toast(message, {
        id,
        title,
        variant: "danger",
      });
    } else {
      // For test environments or when app is not available
      console.error("Error:", title, message);
    }
  }

  return Promise.reject(error);
}
